/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleSummary } from './VehicleSummary';
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
    VehicleSummaryToJSONTyped,
} from './VehicleSummary';

/**
 * A single completed batch's vehicle results. One event fires per
 * completed batch, in arrival order (not necessarily by batch_num).
 * 
 * @export
 * @interface VehicleStreamVehicles
 */
export interface VehicleStreamVehicles {
    /**
     * 
     * @type {string}
     * @memberof VehicleStreamVehicles
     */
    type: VehicleStreamVehiclesTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof VehicleStreamVehicles
     */
    batchNum: number;
    /**
     * 
     * @type {Array<VehicleSummary>}
     * @memberof VehicleStreamVehicles
     */
    items: Array<VehicleSummary>;
}


/**
 * @export
 */
export const VehicleStreamVehiclesTypeEnum = {
    Vehicles: 'vehicles'
} as const;
export type VehicleStreamVehiclesTypeEnum = typeof VehicleStreamVehiclesTypeEnum[keyof typeof VehicleStreamVehiclesTypeEnum];


/**
 * Check if a given object implements the VehicleStreamVehicles interface.
 */
export function instanceOfVehicleStreamVehicles(value: object): value is VehicleStreamVehicles {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('batchNum' in value) || value['batchNum'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function VehicleStreamVehiclesFromJSON(json: any): VehicleStreamVehicles {
    return VehicleStreamVehiclesFromJSONTyped(json, false);
}

export function VehicleStreamVehiclesFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleStreamVehicles {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'batchNum': json['batch_num'],
        'items': ((json['items'] as Array<any>).map(VehicleSummaryFromJSON)),
    };
}

export function VehicleStreamVehiclesToJSON(json: any): VehicleStreamVehicles {
    return VehicleStreamVehiclesToJSONTyped(json, false);
}

export function VehicleStreamVehiclesToJSONTyped(value?: VehicleStreamVehicles | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'batch_num': value['batchNum'],
        'items': ((value['items'] as Array<any>).map(VehicleSummaryToJSON)),
    };
}

